// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { localize } from 'i18n-calypso'
import Cookies from 'js-cookie'

// Internal Dependencies:
import Text from 'church-theme-library/components/Form/Text'

// Redux:
import { getPageData } from 'church-theme-library/redux/actions/page'

class _PasswordProtected extends React.Component {
	constructor() {
		super()

		this.state = {
			pagePassword: '',
			pagePasswordError: false
		}
	}

	handleChange = ( id, value ) => {
		this.setState( {
			[ id ]: value
		} )
	}

	handleSubmitPagePassword = ( e ) => {
		e.preventDefault()
		const form = e.currentTarget
		const { dispatch, page } = this.props
		const { pagePassword } = this.state

		if ( ! page ) {
			return
		}

		Cookies.set( `${page.post_type}_password_${page.slug}`, pagePassword )

		dispatch(
			getPageData( {
				type: page.post_type,
				slug: page.slug,
				force: true
			} )
		)
	}

	render() {
		const { translate } = this.props
		const { pagePassword } = this.state

		return (
			<div className="section-post-content">
				<div className="-inner">
					<div className="primary-content-inner primary-content-is-ready">
						<div className="content-body-wrap">
							<div className="content-body">
								<div className="content-body-text">
									<div className="content-locked">
										<p>{ translate( `This content is password protected. To view it please enter the password below:` ) }</p>

										<form className="form" action="" onSubmit={ this.handleSubmitPagePassword }>
											<Text
												id="pagePassword"
												label={ translate( `Enter password` ) }
												onChange={ this.handleChange }
												type="password"
												uncontrolled={ true }
											/>

											<div className="form-item">
												<button className="button" type="submit"><span className="-state"></span><span className="-progress"></span>{ translate( `Submit` ) }</button>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	const page = ownProps.pageOverride ? ownProps.pageOverride : state.page.selected

	return {
		page
	}
}

export default localize(
	connect( mapStateToProps )( _PasswordProtected )
)
